import { Select } from "antd";
import _ from "lodash";
import React from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import styled from "styled-components";

import { Button } from "@components/Button";
import ErrorValidate from "@components/ErrorValidate";
import { StyledInput } from "@components/Input";
import { Text } from "@components/Text";
import { COLOR_DARK, COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";
import { getUserExtraCustomers } from "@utils/getUserExtraCustomers";
import { fetchAPI } from "@utils/https/fetchAPI";
import { VALIDATE_RULES } from "@validate/index";

const FormContainer = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 2px;
`;

const Line = styled.div`
  width: 100%;
  height: 1px;
  margin-bottom: 8px;
  background-color: rgba(0, 0, 0, 0.1);
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  height: 40px;
`;

export const FormCreate = ({
  setDataList = () => undefined,
  customerOptions = [],
  setIsModalVisible,
  dataList,
  userProfile,
}) => {
  const allCustomers = getUserExtraCustomers();
  const category_customer_id = _.get(userProfile, ["category_customer_id"]);

  const { control, handleSubmit } = useForm();

  const onHandleCreate = async (data) => {
    console.log("data :>> ", data);
    const name = _.get(data, ["name"]);
    const disk_limit = _.get(data, ["disk_limit"]);
    const category_customer_id = _.get(data, ["customerType"]);
    const user_type = _.get(userProfile, ["user_type"]);

    const resp = await fetchAPI({
      method: "post",
      path: "/api/v1/location-create",
      isAuth: true,
      data: {
        name,
        disk_limit,
        category_customer_id,
        user_type,
      },
    });

    console.log("resp :>> ", resp);
    if (_.get(resp, ["status"])) {
      const results = _.chain(resp).get(["result"]).value();
      toast.success("Create Location Success.");
      setIsModalVisible((prev) => ({ ...prev, isOpen: false }));
      const updateData = _.chain(dataList)
        .thru((list) => {
          return [results, ...list];
        })
        .map((item, index) => {
          return { ...item, key: index + 1, index: index + 1 };
        })
        .value();
      setDataList(updateData);
    }
  };

  const filteredCustomerOptions = _.isNil(category_customer_id)
    ? customerOptions
    : _.filter(customerOptions, (item) => {
        console.log("item :>> ", item);
        const value = _.get(item, ["value"]);
        return _.includes(allCustomers, value);
      });

  console.log("filteredCustomerOptions :>> ", filteredCustomerOptions);

  return (
    <FormContainer onSubmit={handleSubmit(onHandleCreate)} autoComplete="off">
      <Line />
      <InnerContainer>
        <div>
          <Controller
            name="name"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Name
                </Text>
                <StyledInput
                  label="name"
                  {...field}
                  size="large"
                  placeholder="name"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />
          <Controller
            name="customerType"
            control={control}
            rules={_.get(VALIDATE_RULES, ["required"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Customer
                </Text>
                <Select
                  {...field}
                  size="large"
                  showSearch
                  placeholder="Select a customer"
                  optionFilterProp="children"
                  style={{ width: "100%" }}
                  filterOption={(input, option) =>
                    (option?.label ?? "").includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={filteredCustomerOptions}
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />
          <Controller
            name="disk_limit"
            control={control}
            rules={_.get(VALIDATE_RULES, ["number"])}
            render={({ field, fieldState: { error } }) => (
              <div>
                <Text
                  color={COLOR_DARK}
                  fontSize="14px"
                  style={{ marginBottom: 4, marginLeft: 4 }}
                >
                  Disk limit (GB)
                </Text>
                <StyledInput
                  label="disk_limit"
                  {...field}
                  size="large"
                  placeholder="Disk limit"
                />
                <ErrorValidate justify="start" error={error} />
              </div>
            )}
          />
        </div>

        <ButtonContainer>
          <Button
            type="submit"
            color={COLOR_GREEN}
            fontColor={COLOR_WHITE}
            fontSize="16px"
            padding="5px 20px"
          >
            Save
          </Button>
        </ButtonContainer>
      </InnerContainer>
    </FormContainer>
  );
};
